import { matchClientName } from '../integrations/matchClientName'
import type { IntegrationId } from '../integrations/types'

import { useConnectedApps } from './useConnectedApps'
import type { ConnectedApp } from './useConnectedApps'

/**
 * Groups the account's MCP connections under the integration each one belongs
 * to, so a surface can ask what is connected without repeating the category
 * filter or the name matching.
 *
 * An integration is absent while the query is in flight and when it fails, so
 * both cases render as an account with nothing connected rather than blocking
 * the page.
 */
export const useIntegrationConnections = (): Map<
  IntegrationId,
  ConnectedApp[]
> => {
  const { connectedApps } = useConnectedApps()

  const connectionsByIntegration = new Map<IntegrationId, ConnectedApp[]>()

  for (const connection of connectedApps.filter(
    (app) => app.category === 'mcp',
  )) {
    const integration = matchClientName(connection.name)

    if (!integration) {
      continue
    }

    const existing = connectionsByIntegration.get(integration.id)

    if (existing) {
      existing.push(connection)
    } else {
      connectionsByIntegration.set(integration.id, [connection])
    }
  }

  return connectionsByIntegration
}
